// extracted by mini-css-extract-plugin
export default {"notify":"c6swNLo1"};